module.exports = __webpack_public_path__ + "static/img/fruits_lemon.8b871cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fruits_lemon.png
// module id = Rrg0
// module chunks = 1